const PHONE = '905055600419';

export default function MidPageCTA() {
  return (
    <section className="py-14 bg-sky-600 relative overflow-hidden">
      {/* Decorative */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-80 h-80 bg-white rounded-full -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-64 h-64 bg-white rounded-full translate-x-1/4 translate-y-1/4" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center">
        <p className="text-sky-200 text-sm font-semibold mb-2 uppercase tracking-widest">Hemen Harekete Geçin</p>
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-4">
          Size Uygun Temizlik Hizmeti İçin<br className="hidden sm:block" /> Hemen İletişime Geçin
        </h2>
        <p className="text-sky-100 text-base mb-8 max-w-xl mx-auto">
          Yoğunluk nedeniyle randevu saatleri değişebilir — Hızlı randevu almak için şimdi iletişime geçin.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href={`https://wa.me/${PHONE}?text=${encodeURIComponent('Merhaba, temizlik hizmeti hakkında bilgi almak istiyorum.\n\nAd Soyad:\nTelefon:\nKonum:\nTarih:\nSaat:')}`}
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center justify-center gap-3 bg-emerald-500 hover:bg-emerald-400 text-white font-bold px-8 py-4 rounded-full transition-all text-lg whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-xl" />
            WhatsApp
          </a>
          <a
            href="tel:05055600419"
            className="inline-flex items-center justify-center gap-3 bg-white hover:bg-sky-50 text-sky-700 font-bold px-8 py-4 rounded-full transition-all text-lg whitespace-nowrap"
          >
            <i className="ri-phone-fill text-xl" />
            0505 560 04 19
          </a>
        </div>
      </div>
    </section>
  );
}
